import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from '@resurs/midas-react'
import Iframe from '../../../../internal/Iframe'

import { getText } from '../../../../internal/TextLabels'

class PrintModalUI extends Component {
  handleClose() {
    this.props.onClose()
  }

  render() {
    const props = {
      hideClose: true,
      show: this.props.show,
      title: this.props.title,
      onClose: () => this.handleClose(),
      actions: (
        <Button type="primary" onClick={() => this.handleClose()}>
          {this.props.closeText || getText('default.continue')}
        </Button>
      ),
    }
    return (
      <div>
        {this.props.show && (
          <Modal {...props}>
            <Iframe print frame={this.props.url} />
          </Modal>
        )}
      </div>
    )
  }
}

PrintModalUI.propTypes = {
  title: PropTypes.string,
  closeText: PropTypes.string,
  url: PropTypes.string.isRequired,
  show: PropTypes.bool,
  onClose: PropTypes.func,
}

PrintModalUI.defaultProps = {
  title: '',
  closeText: null,
  show: false,
  onClose: () => {},
}

export default PrintModalUI
